module.exports = __webpack_public_path__ + "media/mobile_1080x1920_v2.3508db68.mp4";